import React from "react";
import "./style.scss";
import SectionTitle from "../shared/SectionTitle";
import { FaBriefcase, FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";
import { GoDotFill } from "react-icons/go";

const experienceData = [
    {
        title: "Director | Full Stack Development & AI Solutions",
        specialization: "React.js • Node.js • Strapi • Agentic AI",
        company: "Komputer Juncture (India) Pvt. Ltd.",
        location: "Patna, India",
        duration: "Aug 2026 - Present",
        details: [
            "Appointed as Director, leading technical strategy and full-stack AI solution delivery for clients across education, wellness, and real estate domains.",
            "Responsible for end-to-end ownership from client requirement gathering and system design through development, deployment, and production maintenance.",
            "Building AI-powered platforms, CMS-driven websites, and automation solutions using React.js, Node.js, Strapi, PostgreSQL, OpenAI API, LangChain, CrewAI, Vercel, and Render."
        ],
        tags: ["System Design", "Agentic AI", "CrewAI", "Strapi CMS", "Full Stack Leadership"]
    },
    {
        title: "Software Developer | Full Stack and AI Solutions",
        specialization: "ASP.NET Core • React.js • Node.js • OpenAI API",
        company: "NIIT Ltd",
        location: "Gurugram, India",
        duration: "Sep 2022 - Jul 2026",
        details: [
            "Engineered 12+ enterprise modules using ASP.NET Core, React.js, Node.js, MongoDB, and SQL Server, following distributed service architecture and system design principles.",
            "Improved API response time by 35% through SQL indexing and query tuning; automated Excel workflows reducing manual effort by 40%.",
            "Integrated OpenAI API and LangChain for contextual search; cut production defects by 25% via regression checklists adopted team-wide.",
            "Maintained Docker + GitHub Actions CI/CD pipelines; mentored 4 junior developers through 20+ sessions on API design, algorithms, and best practices."
        ],
        tags: ["ASP.NET Core", "React.js", "Node.js", "OpenAI API", "SQL Server", "CI/CD"]
    }
];

const Experience = () => {
    return (
        <section id="experience" className="experience-section">
            <div className="layout">
                <SectionTitle
                    title="EXPERIENCE"
                    tagline="My professional journey in software development."
                />

                <div className="timeline-container">
                    {experienceData.map((job, index) => (
                        <div key={index} className="timeline-item">
                            <div className="timeline-line-wrapper">
                                <div className="timeline-dot">
                                    <FaBriefcase className="dot-icon" />
                                </div>
                                <div className="timeline-line"></div>
                            </div>

                            <div className="experience-card glass-effect">
                                <div className="card-header">
                                    <div className="title-group">
                                        <h3 className="job-title">{job.title}</h3>
                                        <span className="specialization">{job.specialization}</span>
                                    </div>
                                    <div className="duration-pill">
                                        <FaCalendarAlt /> {job.duration}
                                    </div>
                                </div>

                                <div className="company-info">
                                    <span className="company-name">{job.company}</span>
                                    <span className="divider">|</span>
                                    <span className="location"><FaMapMarkerAlt /> {job.location}</span>
                                </div>

                                <ul className="job-details">
                                    {job.details.map((detail, dIndex) => (
                                        <li key={dIndex}>
                                            <GoDotFill className="bullet" />
                                            <p>{detail}</p>
                                        </li>
                                    ))}
                                </ul>

                                <div className="skill-tags">
                                    {job.tags.map((tag, tIndex) => (
                                        <span key={tIndex} className="tag">{tag}</span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Experience;